/*=========================================================================================
  File Name: globalComponents.js
  Description: Here you can register components globally
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from 'vue'
import VxTooltip from './layouts/components/vx-tooltip/VxTooltip.vue'
import VxCard from './components/vx-card/VxCard.vue'
import VxList from './components/vx-list/VxList.vue'
import VxBreadcrumb from './layouts/components/VxBreadcrumb.vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import VxInputGroup from './components/vx-input-group/VxInputGroup.vue'
import DebugBar from '@/components/DebugBar.vue'

Vue.component(VxTooltip.name, VxTooltip)
Vue.component(VxCard.name, VxCard)
Vue.component(VxList.name, VxList)
Vue.component(VxBreadcrumb.name, VxBreadcrumb)
Vue.component(FeatherIcon.name, FeatherIcon)
Vue.component(VxInputGroup.name, VxInputGroup)
Vue.component('DebugBar', DebugBar)

// v-select component
import vSelect from 'vue-select'

// Set the components prop default to return our fresh components
vSelect.methods.deselect = () => ({
  Deselect: {
    render: (createElement: any) =>
      createElement('feather-icon', {
        props: {
          icon: 'XIcon',
          svgClasses: 'w-4 h-4 mt-1'
        }
      })
  },
  OpenIndicator: {
    render: (createElement: any) =>
      createElement('feather-icon', {
        props: {
          icon: 'ChevronDownIcon',
          svgClasses: 'w-5 h-5'
        }
      })
  }
})

Vue.component(vSelect)

import LoadScript from 'vue-plugin-load-script'
Vue.use(LoadScript as any)

import VTooltip from 'v-tooltip'
Vue.use(VTooltip)

import VueSecureHTML from 'vue-html-secure';
Vue.use(VueSecureHTML);

import VideoPlayer from 'vue-videojs7'

Vue.use(VideoPlayer, /* {
  options: global default videojs options,
  events: global videojs videojs events
} */)

import vClickOutside from 'v-click-outside'
Vue.use(vClickOutside)

import VueMeta from 'vue-meta'
Vue.use(VueMeta)
